// Transcript-review copy. Used by the Phase 2 task 2.2 redesign that flips
// the TranscriptsPage to lead with extractions and demote transcript text to
// a secondary tab.

export const transcriptsCopy = {
  // Tabs
  tabExtractions: 'Extractions',
  tabTranscript: 'Transcript',

  // Section headings
  sectionExtractionsHeading: 'Extracted action items',
  sectionTranscriptHeading: 'Meeting transcript',

  // Per-extraction actions
  actionAccept: 'Accept into plan',
  actionAssign: 'Assign',
  actionDismiss: 'Dismiss',

  // Batch actions
  batchAcceptAll: 'Accept all',
  batchAcceptSelected: 'Accept selected',

  // Assign dialog
  assignDialogTitle: 'Assign this action',
  assignDialogBody:
    'Pick a target. You can delegate the item to another executive in your tenant, link it to a project, or both.',
  assignToExecutiveLabel: 'Executive',
  assignToProjectLabel: 'Project',
  assignSelectExecutive: 'Select an executive',
  assignSelectProject: 'Select a project',
  assignConfirm: 'Assign',
  assignCancel: 'Cancel',
  assignValidationChoose: 'Choose an executive, a project, or both.',

  // Dismiss toggle
  toggleShowDismissed: 'Show dismissed',
  dismissedHint: 'Dismissed items are hidden by default.',

  // Confidence badge tooltip
  confidenceTooltipHigh: 'High confidence: the AI is very sure this is a real action item.',
  confidenceTooltipMedium: 'Medium confidence: worth reviewing before accepting.',
  confidenceTooltipLow: 'Low confidence: the AI is unsure. Dismiss or edit before accepting.',

  // Empty / state copy
  noExtractionsFound: 'No action items were extracted from this transcript.',
  allHandledHeading: 'All extractions are handled',
  allHandledBody: 'Every extracted item has been accepted, assigned, or dismissed.',

  // Status labels for state chips
  statusAccepted: 'Accepted',
  statusDismissed: 'Dismissed',

  // Tooltips
  editTooltip: 'Edit before accepting',
  cancelEditTooltip: 'Cancel edit',
} as const;
